import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { fadeInOut } from '@shared/animations';
import { ZbpIconComponent } from '@shared/zbp-icon/zbp-icon';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';
import * as _ from 'lodash';
import { map, Observable, timer } from 'rxjs';

@Component({
  selector: 'zbp-branded-fallback-download',
  templateUrl: './branded-fallback-download.component.html',
  styleUrls: ['./branded-fallback-download.component.scss'],
  animations: [fadeInOut],
  imports: [
    ZbpIconComponent,
  ]
})
export class BrandedFallbackDownloadComponent implements OnInit  {

  protected readonly zbpIconNames = zbpIconNames;

  id: string = '';
  url: SafeUrl = '';
  filename: string = '';
  target: string = '';
  visible = false;
  private pattern: RegExp;

  @Input() displayIcon = false;
  @Input() idPrefix: string = 'fallbackDownload';
  @Input() classes: string = '';
  @Input() downloadPrompt: string = 'If the file download did not start automatically, ';
  @Input() downloadLinkText: string = 'please click here.';
  @Output() clicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @ViewChild('link', { static: true }) link: ElementRef<HTMLAnchorElement>;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.pattern = new RegExp(window.location.host);
    this.id = _.uniqueId(this.idPrefix);
  }

  linkClicked(): void {
    this.clicked.emit(true);
  }

  get ariaState(): string {
    return this.visible ? 'false' : 'true';
  }

  get tabIndexState(): string {
    return this.visible ? '0' : '-1';
  }

  get defaultClasses(): string {
    const visibility = this.visible ? 'Visible' : 'Hidden';
    return `fallbackDownload fallbackDownload${visibility} ${this.classes}`;
  }

  startDownload(url: string, filename: string): Observable<boolean> {
    const sameOrigin = this.pattern.test(url);
    this.url = this.sanitizer.bypassSecurityTrustUrl(url);
    this.filename = sameOrigin ? filename : '';
    this.target = !sameOrigin ? '_blank' : '';
    this.visible = true;

    return timer(500)
      .pipe(map(() => {
        this.link.nativeElement.focus();
        this.link.nativeElement.click();
        return true;
      }));
  }

  /**
   * Resets properties to default state.
   *
   * If the component is used in a context where local state of its parent component can change, then this should be
   * called when that state changes.
   */
  reset(): void {
    this.visible = false;
    this.id = '';
    this.url = null;
    this.filename = '';
    this.target = '';
  }
}
